import React, { useState, useEffect,useRef } from 'react';
import InvoiceApi from '../api/InvoiceApi';
import SettingApi from '../api/SettingApi';
import { ImCancelCircle } from 'react-icons/im';
import TransactionForm from '../transactions/TransactionForm';
import TransactionApi from '../api/TransactionApi';
import { PayPalButtons, PayPalScriptProvider } from '@paypal/react-paypal-js';
import { GridLoader, SquareLoader } from 'react-spinners';

const PublicInvoice = () => {
  const [state, setState] = useState([]);
  const [details, setDetails] = useState("");
  const [setting, setSetting] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const [message, setMessage] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [totalPaidAmount, setTotalpaidAmount] = useState("");
  const [totalAmount, setTotalAmount] = useState("");
  const [showPayPal, setShowPayPal] = useState(false);
  const [loading, setLoading] = useState(false);
  
  useEffect(() => {
    getSettings();
  }, []);

  useEffect(() => {
    if (details) {
      getTransactions(details.id);
    }
  }, [details]);

  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const invoiceId = urlParams.get('inv');
  const invoiceData= state?.find(invoice => invoice.invoice_no === invoiceId);

  useEffect(() => {
    if (invoiceData) {
      setDetails(invoiceData.data ? invoiceData.data : invoiceData);
      const selectedItemsData = JSON.parse(
        invoiceData.invoice_items_data
          ? invoiceData.invoice_items_data
          : invoiceData.item_data
      );
      setSelectedItems(selectedItemsData);
    }
  }, [invoiceData]);

  useEffect((dueAmounts) => {
      if(dueAmounts === 0){
            updateInvoice(invoiceData.id ? invoiceData.id : invoiceData.data.id, false);
          }
  },[invoiceData])

  
  const getInvoice = async () => {
    setLoading(true);
    try {
        const res = await InvoiceApi.index();
        if (Array.isArray(res)) {
            const activeInvoices = res.filter(invoice => !invoice.deleted_at);
            setState(activeInvoices);
        } else {
            console.error("API response is not an array:", res);
        }
    } catch (error) {
        console.error("Error fetching invoices:", error);
    } finally {
        setLoading(false);
    }
};

   
const updateInvoice = async (id, refresh = true) => {
  const res = await InvoiceApi.update({id: id, make_paid: true});
  if (res) {
    setMessage(res.message);
    getInvoice();
      toggleDetails();
    setTimeout(() => {
      setMessage('');
   }, 2000);
  }
};

  const getTransactions = async (id) => {
    try {
      const res = await TransactionApi.invoiceDetails(id);
      if (res) {
        let paidAmounts = 0;
        res.map(item =>{ const amountPid = parseInt(item.amount)
          paidAmounts +=amountPid;
          setTotalpaidAmount(paidAmounts);
        })
        const totalAmouts = details.amount - details.discount;
        setTotalAmount(totalAmouts.toFixed(0));
      }

    } catch (error) {
      console.error('Error fetching transactions:', error);
    }
  };

  const getSettings = async () => {
    const res = await SettingApi.index();  
    setSetting(res); 
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = date.getDate();
    const month = date.getMonth() + 1;
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  const dueAmounts = totalAmount-totalPaidAmount;
  const handlePayPalClick = () => {
    setShowPayPal(prevState => !prevState);
  };


  useEffect(() => {
    getInvoice();
}, []);



  return (
    <>
      {showModal ? (
        <>
          <div
            className="fixed justify-center items-center flex overflow-x-hidden overflow-y-auto inset-0 z-50 outline-none focus:outline-none"
          >
            <div className="relative w-auto my-6 mx-auto max-w-7xl">
              <div className="border-0 rounded-lg shadow-lg relative flex flex-col modal-width bg-white outline-none focus:outline-none">
                <div className="flex items-start justify-between rounded-t">
                  <a
                    className="d-none  mt-2 !ml-2 text-2xl text-gray-400 cursor-pointer"
                    onClick={() => setShowModal(false)}
                  >
                    <ImCancelCircle />
                  </a>
                </div>
                <div className="relative flex-auto">
                  <TransactionForm invoiceData={details} onSubmits={getInvoice} toogle={toggleDetails}  paidAmount={totalPaidAmount} modal="true" />
                </div>
              </div>
            </div>
          </div>
          <div className="fixed opacity-25 inset-0 z-40 bg-black"></div>
        </>
      ) : null}
      {message && (
        <div
          className="bg-blue-100 border-t border-b border-blue-500 text-blue-700 px-4 py-3"
          role="alert"
        >
          <p className="font-bold">{message}</p>
        </div>
      )}
 
      {loading ? (
        <div className="flex justify-center items-center h-[50vh]">
          <GridLoader />
        </div>
      ) : invoiceData ? (
              <div className="px-8 py-4 sm:px-6 lg:px-8 max-w-[1420px] mx-auto pb-12">
                <div className="">
              
              
                  <div className="flex flex-col p-4 sm:p-10 bg-white shadow-md rounded-xl print:-mt-25">
                    <div className="flex justify-between">
                      <div>
                        <h1 className="mt-2 text-lg md:text-xl font-bold text-blue-600 uppercase">
                          {setting.company_name}
                        </h1>
                        <p className="mt-2 text-md ">
                          {setting.address}
                        </p>
                        <p className="mt-2 text-md ">
                          {setting.phone}
                        </p>
                        <p className="mt-2 text-md ">
                        {details.type === 'bill' ? 'Bill' : 'Invoice'} <span> To:</span>
                        </p>
                        <p className="mt-2 text-md font-semibold">
                          {details.contact_name}
                        </p>
                          <p className="mt-2 text-md font-semibold">
                          {details.contact_email}
                          </p>
                      </div>
                      <div className="text-end">
                        <h2 className="text-2xl md:text-3xl font-semibold text-gray-800">
                          {details.invoice_no}
                        </h2>
                      </div>
                    </div>
                    <div className="mt-8 ">
                      <div className="text-end space-y-2">
                          <dl className="grid grid-cols-3 text-end ">
                            <dt className="col-span-2 font-semibold text-gray-800 ">{details.type === 'bill' ? 'Bill' : 'Invoice'} <span> date:</span></dt>
                            <dd className=" col-span-1 text-gray-500">{formatDate(details.issued_at)}</dd>
                          </dl>
                          <dl className="grid grid-cols-3 text-end">
                            <dt className="col-span-2 font-semibold text-gray-800">Due date:</dt>
                            <dd className="col-span-1 text-gray-500">{formatDate(details.due_at)}</dd>
                          </dl>
                      </div>
                    </div>
                    <div className="mt-6">
                      <div className="border border-gray-200 p-4 rounded-lg space-y-4">
                        <div className="grid grid-cols-4">
                          <div className="sm:col-span-2 text-xs font-medium text-gray-500 uppercase">
                            Item
                          </div>
                          <div className="text-start text-xs font-medium text-gray-500 uppercase">
                            Qty
                          </div>
                          <div className="text-end text-xs font-medium text-gray-500 uppercase">
                            Rate
                          </div>
                        </div>
                        <div className="block border-b border-gray-200"></div>
                        {selectedItems.map((item) => (
                          <div className="grid grid-cols-4 gap-2" key={item.id}>
                            <div className="col-span-2">
                              <h5 className="sm:hidden text-xs font-medium text-gray-500 uppercase">Item</h5>
                              <p className="font-medium text-gray-800">{item.name}</p>
                            </div>
                            <div>
                              <h5 className="sm:hidden text-xs font-medium text-gray-500 uppercase">
                                Qty
                              </h5>
                              <p className="text-gray-800">{item.quantity}</p>
                            </div>
                            <div>
                              <h5 className="sm:hidden text-xs font-medium text-gray-500 uppercase">
                                Rate
                              </h5>
                              <p className="text-gray-800 text-end">${details.type === 'bill' ? item.purchase_price : item.sale_price}</p>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                    <div className="mt-5 flex flex-col sm:justify-end">
                        <div className="space-y-2">
                        <div className="grid gap-4">
                        <div className="grid grid-cols-3 text-end">
                        <div className="col-span-2 font-semibold text-gray-800">Subtotal:</div>
                        <div className="col-span-1 text-gray-500">${details.amount}</div>
                        </div>
                        {details.discount && !isNaN(details.discount) ? (
                        <div className="grid grid-cols-3 text-end">
                        <dt className="col-span-2 font-semibold text-gray-800">Discount:</dt>
                        <dd className="col-span-1 text-gray-500">${Number(details.discount).toFixed(0)}</dd>
                        </div>
                        ) : ''}
                        <div className="grid grid-cols-3 text-end">
                        <div className="col-span-2 font-semibold text-gray-800">Total:</div>
                        <div className="col-span-1 text-gray-500">${totalAmount}</div>
                        </div>
                        {totalPaidAmount ?
                        <div className="grid grid-cols-3 text-end">
                        <div className="col-span-2 font-semibold text-gray-800">Paid:</div>
                        <div className="col-span-1 text-gray-500">${totalPaidAmount}</div>
                        </div> : ''}

                        <div className="grid grid-cols-3 text-end">
                        <div className="col-span-2 font-semibold text-gray-800 ">Dues:</div>
                        <div className="col-span-1 text-gray-500 ">${dueAmounts}</div>
                        </div>

                        </div>
                        </div>

                        {/* PayPal  */}
                        <div className='flex justify-end'>
                        {
                        dueAmounts > 0 && <button className='bg-gray-600 text-white px-4 py-1.5 rounded-md my-4' onClick={handlePayPalClick}>Pay With PayPal</button>
                        }
                        </div>
                        {/* Payment Gateway */}
                        <div className='h-[60px] flex justify-end w-full'>
                        {(showPayPal && Number(dueAmounts) > 0)  ? (
                          <PayPalScriptProvider options={{ "client-id": setting?.paypal_client_id, components: "buttons", dataNamespace: "paypal_sdk" }}>
                              <PayPalButtons style={{ layout: "vertical" }}
                                            fundingSource="paypal"
                                            disableFunding="paylater" 
                                            createOrder={(data, actions) => {
                                                
                                                    return actions.order.create({
                                                        purchase_units: [
                                                            { amount: { currency_code: "USD", value: dueAmounts }, invoice_id: invoiceData.invoice_id }
                                                        ],
                                                    });
                                                }}

                                                onApprove={async (data, actions) => {
                                                  return actions.order.capture().then(async (details) => {
                                                      try {
                                                          const paymentData = {
                                                              amount: dueAmounts,
                                                              type: "income",
                                                              id: invoiceData.id,
                                                              document_id: invoiceData.id,
                                                              contact_id : invoiceData.contact_id,
                                                              category_id : invoiceData.category_id,
                                                              payment_method: "PayPal",
                                                              reference: JSON.stringify(details),
                                                              paid_at: details.update_time,
                                                              deleted_at: '',
                                                              data: details,
                                                          };
                                                          const res = await TransactionApi.save(paymentData);
                                                          updateInvoice(invoiceData.id)
                                                          getTransactions(invoiceData.id);
                                                      } catch (error) {
                                                          console.error("Error processing payment:", error);
                                                      }
                                                  });
                                              }}
                                              
                                            onError={(err) => {
                                                console.error("PayPal error:", err);
                                                
                                            }}
                                />
                          </PayPalScriptProvider>
                          
                        ) : ''}

                        </div>
                    </div>
                  </div>
      
                </div>
              </div>
      ) : (
        <div className="px-8 py-4 sm:px-6 lg:px-8 max-w-[1420px] mx-auto pb-12">
          <div className="text-center p-4 bg-red-100 text-red-700 border border-red-500 rounded-md">
            <p className="font-semibold">Invalid invoice data found</p>
          </div>
        </div>
      )}
          
    </>
  );
};

export default PublicInvoice;
